// @flow

import React, { Component } from 'react';
import { Card, Icon, Text, Image } from '../';
import FileInput from './FileInput';
import Progress from '../Progress/Progress';
import { breakpoints } from '../../../stylesheets';
import { getWidth, apiClient } from '../../../utils';

type Props = {
  value: Number,
  text: String,
  handleUploadFile?: Function,
  handleRemoveFile?: Function,
  data: Object,
  uploadImmediately?: Boolean,
  className?: String,
  addPost?: Boolean,
  bg?: String,
  icon?: String,
  Icon?: Object,
  removable?: Boolean,
  imgClassName?: String,
  removeIconClassName?: String,
};

export default class Uploader extends Component<Props> {
  static defaultProps = {
    handleUploadFile: () => ({}),
    handleRemoveFile: () => ({}),
    uploadImmediately: true,
    removable: true,
  };

  state = {
    file: this.props.value,
    src: this.props.value,
    showProgress: false,
    error: null,
    progress: 0,
    removeLoading: false,
  };

  UNSAFE_componentWillUpdate(nextProps) {
    if (this.props.value !== nextProps.value && !nextProps.uploadImmediately) {
      this.setFile({ target: { files: [nextProps.value] } }, false);
      // if (typeof nextProps.value === 'string') {}
      this.setState({ src: nextProps.value });
    }
  }

  handleFile = () => this._fileInput.click();

  setFile = (e, hasCallBack = true) => {
    let reader = new FileReader();
    reader.onloadend = () => this.setState({ src: reader.result });

    if (e.target.files[0] && e.target.files[0] instanceof Blob)
      reader.readAsDataURL(e.target.files[0]);

    this.setState(
      { file: e.target.files[0], showProgress: this.props.uploadImmediately },
      () => hasCallBack && this.handleUploadFile()
    );
  };

  handleUploadFile = async () => {
    const { uploadImmediately, handleUploadFile, data } = this.props;
    const { file } = this.state;
    if (uploadImmediately) {
      try {
        const response = await apiClient.post(
          '/media/upload',
          {
            data: { ma: file, ft: data.ft, fi: data.fi },
            type: 'formData',
          },
          {
            onUploadProgress: (progressEvent) =>
              this.setState({
                progress: Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                ),
              }),
          }
        );
        await handleUploadFile(response);
        this.setState({ showProgress: false });
      } catch (error) {
        this.setState({ showProgress: false, error });
      }
    } else handleUploadFile(file);
  };

  handleRemoveFile = async () => {
    const { uploadImmediately, handleRemoveFile } = this.props;
    if (uploadImmediately) {
      try {
        const response = await apiClient.post('/media/remove', {
          data: { hh: this.props.data.hash },
        });
        await handleRemoveFile(response);
        await this.setState({ removeLoading: false });
      } catch (error) {
        await this.setState({ removeLoading: false, error });
      }
    } else handleRemoveFile();
  };

  removeFile = () =>
    this.setState(
      { file: null, showProgress: false, removeLoading: true },
      () => {
        this._fileInput.value = '';
        this.handleRemoveFile();
      }
    );

  render() {
    const {
      addText,
      addedText,
      className,
      name,
      icon,
      bg,
      removable,
      children,
      imgClassName,
      removeIconClassName = '',
    } = this.props;
    const { file, src, showProgress, progress } = this.state;
    const w = getWidth();

    return (
      <>
        <Card
          hasBorder
          type="white"
          className={`position-relative overflow-hidden radius-sm b-lighterGray d-flex bg-${
            bg || 'backgroundWhite'
          } ${className} align-items-center h-100 hover-bg-palePrimary p-1 pointer radius-sm w-100`}
          hasAnimation={false}
          hasShadow={false}
          onClick={(e: Event) =>
            file ? e.preventDefault() : this.handleFile()
          }
        >
          {children}
          {showProgress ? (
            <>
              <Image
                src={src}
                alt="upload"
                className="h-100 mw-5 Mw-5 radius-sm object-fit-cover"
                showPlaceholder={false}
              />
              {addedText && (
                <Text
                  type="label"
                  className="my-0 my-1 w-100 text-primary px-3 cursor-pointer"
                >
                  {addedText}
                </Text>
              )}
              <div className="position-absolute bottom-0 top-0 left-0 right-0 h-100">
                <Progress value={progress} />
              </div>
            </>
          ) : file ? (
            <>
              <img
                src={src}
                alt="upload"
                className={
                  imgClassName ||
                  'w-5 mw-5 h-5 Mh-100 radius-sm object-fit-cover'
                }
                showPlaceholder={false}
              />
              {addedText && (
                <Text
                  type="label"
                  className="my-0 my-1 w-100 text-primary px-2 cursor-pointer"
                >
                  {addedText}
                </Text>
              )}
              {removable ? (
                <Icon
                  size={28}
                  name="e-remove"
                  color="primary"
                  className={`cursor-pointer pl-2 ${removeIconClassName}`}
                  onClick={this.removeFile}
                />
              ) : null}
            </>
          ) : (
            <>
              <div className="h-5 w-5">
                {this.props.Icon ? (
                  <Icon
                    name={this.props.Icon.name}
                    size={50}
                    color="primary"
                    className="cursor-pointer px-0 radius-sm object-fit-cover flex-center-center mr-2"
                    bold
                  >
                    {this.props.Icon.icon}
                  </Icon>
                ) : (
                  <Icon
                    name={icon || 'image-add'}
                    size={50}
                    color="primary"
                    className="cursor-pointer px-0 radius-sm object-fit-cover flex-center-center mr-2"
                  />
                )}
              </div>
              {addText && (
                <Text
                  type="label"
                  className="my-0 my-1 w-100 text-primary px-3 cursor-pointer"
                >
                  {addText}
                </Text>
              )}
            </>
          )}
          <FileInput
            type="file"
            accept="image/*"
            ref={(ref) => (this._fileInput = ref)}
            onChange={this.setFile}
            name={name}
          />
        </Card>
      </>
    );
  }
}
